module.exports = __webpack_public_path__ + "img/idi-icon-libertad.5588e079.png";